<template>
<div>
    <div v-if="options" >
        <div class="fiery_block" :class="{ 'active' : options[0].active === 1 }" @click="change(options[0])" >
            <div  class="fiery_box">
                <!-- <SvgShapeSvg type="fiery_round" v-if="options[0].active === 0" />
                <SvgShapeSvg :type="'fiery_round' + '_active'" v-if="options[0].active === 1" /> -->
                <SvgShapeSvg :type="options[0].active === 1 ? 'fiery_round_active' : 'fiery_round'" />
            </div>
            <div>
                <div class="for_desktop"><span>Fiery Rounds</span></div>
            </div>
            <div class="svg_block for_desktop" >
                <!-- <SvgHeaderSvg :type="'ask'" v-if="options[0].active === 0" class="svg_box" @click="showModal()"/>
                <SvgHeaderSvg :type="'ask_white'" v-if="options[0].active === 1" class="svg_box" @click="showModal()"/> -->
                <SvgHeaderSvg :type="options[0].active === 1 ? 'ask_white' : 'ask'" class="svg_box" @click.stop="showModal()"/>
            </div>
            <div class="svg_block for_mobile">
                <!-- <SvgHeaderSvg :type="'ask'" v-if="options[0].active === 0" @click="showModal()" />
                <SvgHeaderSvg :type="'ask_white'" v-if="options[0].active === 1" @click="showModal()"/> -->
                <SvgHeaderSvg :type="options[0].active === 1 ? 'ask_white' : 'ask'" @click.stop="showModal()"/>
            </div>
            <div class="for_mobile shape_label">{{ options[0].label }}</div>
        </div>
    </div>
    <div v-if="flagShowModal">
        <Teleport  to="#teleports">
            <div class="modal fade" data-bs-backdrop="true"  id="fieryRound" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" ref="fieryRound">
                <div class="modal-dialog">
                    <div class="modal-body modal-content">                     
                        <div class="title_block mb-2">
                            <h3 class="mb-0 font-active">Fiery Rounds</h3>
                            <span @click="hideModal"><SvgHeaderSvg type="close" class="largesvg"/></span>
                        </div>
                        <div class="info">
                           <p class="light">With a focus on light return, the fiery cut transforms a diamond into a dazzling centerpiece of any {{ $t('jewelry') }} collection.</p>

                           <NuxtLink :to="localePath('/light-performance-report')"><span>KNOW MORE ABOUT FIERY ROUNDS</span></NuxtLink>
                        </div>
                    </div>
                </div>
            </div>
        </Teleport>
    </div>
</div>

</template>


<script setup>
import {cyolistStore}  from '@/stores/cyolist/cyolist';

const props = defineProps(['name'])
const moduleSubType = inject('moduleSubType')
// const moduleType = inject('moduleType')
const store = cyolistStore();
const localePath = useLocalePath();

const flagShowModal = ref(false)
const fieryRound = ref(null)

const filter = computed(() => {
    return store.getSettingFilter(moduleSubType, props.name);
});

const options = computed(() => {
    return store.getSettingFilterOptions(moduleSubType, props.name);
});

const change = (option) => {
   
   
//    if (option.disabled) {
//             return
//         }
    store.toggleSettingFilter( { reset: false, type: moduleSubType, filter: filter.value, option } )
    
}



const showModal = () => {
        flagShowModal.value = true;
        nextTick(() => {
        const modalElement = fieryRound.value;
        if (modalElement) {
        const modalInstance = new bootstrap.Modal(modalElement);
        modalInstance.show();
        }
        });
    };


    const hideModal = () => {
        const modalElement = fieryRound.value;
        if (modalElement) {
            const modalInstance = bootstrap.Modal.getInstance(modalElement);
            if (modalInstance) {
                modalInstance.hide();
            }
        }
        flagShowModal.value = false;
    };

</script>

<style scoped>
.largesvg {
    transform: scale(1.3);
}

.title_block{
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.title_block span {
    cursor: pointer;
}

h3{
    font-size: 22px;
}

.info span {
    font-size: 14px;
    text-decoration: underline;
    letter-spacing: 1px;
}

.fiery_block {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 150px;
    border: solid 1px #c6cbd4;
    border-radius: 6px;
    height: 40px;
    padding: 4px 8px;
    cursor: pointer;
}

.for_desktop span {
    font-size: 12px;
    color: #6a6161;
    font-weight: 600;
}

.fiery_block.active {
   
    background: var(--green);
}
.light{
    font-size: 16px;
    color: #6a6161;
    font-weight: normal;
    padding-top: 9px;
}
.fiery_block.active span {
    
    color: #fff;
}
.svg_box {
    height: 16px;
    width: 16px;
}


@media(max-width: 767px) {
    .fiery_block {
        border: 1px solid #ccc;
        border-radius: 4px;
        margin-right: 10px;
        width: 100px;
        padding: 10px;
        min-height: 80px;
        justify-content: center;
        flex-direction: column;
        position: relative;
    }
    .svg_block {
        position: absolute;
        top: 0;
        right: 0;
    }

    .shape_label {
        font-weight: 400;
        font-size: 14px;
        color: #6a6161;
        text-transform: capitalize;
        margin-top: 4px;
        text-align: center;
    }
    .fiery_block.active .shape_label {
        color: #fff;
    }

    h3{
        font-size: 20px
    }

}

@media(max-width:500px) {
    .light {
        line-height: 1.3;
    }

    .info span {
        letter-spacing: 1.3px;
    }
}
</style>